import { useEffect, useRef } from "react";
import { useSettings } from "../../contexts/SettingsContext";
import { useToast } from "../../contexts/ToastContext";
import { isRiskFlowCategory } from "./notification-delivery-policy";

type ElectronNotificationBridge = {
  electron?: {
    systemNotification?: {
      show?: (title: string, body?: string) => Promise<unknown>;
    };
  };
};

export function NotificationNativeDeliveryBridge() {
  const { events } = useToast();
  const { preferences } = useSettings();
  const delivered = useRef(new Set<string>());
  const enabled =
    preferences.notifications.deliveryChannels.desktop ||
    preferences.notifications.deliveryChannels.web;

  useEffect(() => {
    events.forEach((event) => {
      if (delivered.current.has(event.id)) return;
      delivered.current.add(event.id);
      if (isRiskFlowCategory(event.kind)) return;
      if (!enabled || !event.nativeDeliveryEligible) return;
      if (document.visibilityState === "visible") return;
      void showNativeNotification(event.title, event.body);
    });
  }, [enabled, events]);

  return null;
}

async function showNativeNotification(title: string, body?: string) {
  const bridge = (window as unknown as ElectronNotificationBridge).electron
    ?.systemNotification?.show;
  if (bridge) {
    try {
      await bridge(title, body);
      return true;
    } catch {
      return false;
    }
  }
  if (
    !("Notification" in window) ||
    window.Notification.permission !== "granted"
  ) {
    return false;
  }
  try {
    new window.Notification(title, body ? { body } : undefined);
    return true;
  } catch {
    return false;
  }
}
